import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatePickerConfiguration } from '@lsq-frontend/common-ui';
import { AnalyticsService } from '@lsq-frontend/angular-shared/features/analytics';
import { SavedDateFilterService } from '../../services/saved-date-filter.service';
import { BaseReportComponent } from './base-report.component';

@Injectable()
export abstract class DateAsOfReportComponent extends BaseReportComponent {
    public filterDate: Date;

    private _analyticsService: AnalyticsService;
    private _activatedRoute: ActivatedRoute;
    private _savedDateFilterService: SavedDateFilterService;

    constructor(public injector: Injector) {
        super(injector);
        this._analyticsService = this.injector.get(AnalyticsService);
        this._activatedRoute = this.injector.get(ActivatedRoute);
        this._savedDateFilterService = this.injector.get(SavedDateFilterService);
    }

    public async dispatchInitialRequest(): Promise<void> {
        const initialTake = await this.getTakeFromUserState();
        const initialDateFilter = this.getInitialDateFilter();

        this.configureDatePicker(initialDateFilter);

        this.dataSource.dispatchRequest({
            take: initialTake,
            asOfDateFilter: initialDateFilter
        });
    }

    public configureDatePicker(initialDateFilter: Date): void {
        this.datePickerConfiguration = new DatePickerConfiguration();
        this.datePickerConfiguration.model = initialDateFilter;
        this.datePickerConfiguration.modelChange = this.handleDatePickerChange.bind(this);
    }

    public handleDatePickerChange(dateFilter: Date): void {
        this._analyticsService.triggerSingleDateFilterEvent(this.analyticsName, dateFilter as Date);

        this.dataSource.dispatchRequest({
            asOfDateFilter: dateFilter
        });

        if (this.savedDateFilterName) {
            this._savedDateFilterService[this.savedDateFilterName] = dateFilter;
        }
    }

    public getInitialDateFilter(): Date {
        const queryParams = this._activatedRoute.snapshot.queryParamMap;

        if (queryParams.get('date')) {
            return new Date(queryParams.get('date'));
        } else if (
            this.savedDateFilterName &&
            this._savedDateFilterService[this.savedDateFilterName]
        ) {
            return this._savedDateFilterService[this.savedDateFilterName];
        } else {
            return new Date();
        }
    }
}
